<template>
  <div class="replacementmonthlystatistics__report__view">
    <div class="reports__subheader">
      <year-month-panel
        @year="(value) => (setYear(value))"
        @month="(value) => (setMonth(value))"
        :selected="{year: gpsDataFilterYear, month: gpsDataFilterMonth}"
      >
      </year-month-panel>

      <employees-panel
        @employeeId="(value) => (employeeId = value)"
        @employeeNumberChanged="(value) => setEmployeeNumber(value)"
        :employeeNumber="gpsDataFilterEmployeeNumber"
        v-if="isAdmin"
      >
      </employees-panel>

      <submit-panel @submit="performLookup" text="Vis" v-if="hasEditRights">
      </submit-panel>
    </div>

    <b-table :data="gpsDataList" :loading="loading" hoverable>
      <b-table-column field="created" label="Dato" v-slot="props">
        {{ format_date(props.row.created) }}
      </b-table-column>

      <b-table-column field="vehicles_ID" label="Køretøj" v-slot="props">
        {{ props.row.vehicles_ID }}
      </b-table-column>

      <b-table-column field="type" label="Type" v-slot="props">
        {{ props.row.type }}
      </b-table-column>

      <b-table-column field="chR_Number" label="CHR Nummer" v-slot="props">
        {{ props.row.chR_Number }}
      </b-table-column>

      <b-table-column field="address" label="Adresse" v-slot="props">
        {{ props.row.address }}
      </b-table-column>

      <b-table-column
        :width="100"
        label="Kørselstype"
        v-if="tripUseOptions"
        field="tripUseId"
        v-slot="props"
      >
        <dropdown
          :sourceList="tripUseOptions"
          :keyPropertyName="(x) => x.value"
          :displayPropertyName="(x) => x.display"
          :selectedValue="props.row.tripUseId"
          @selectionChanged="(tripUse) => (props.row.tripUseId = tripUse)"
        >
        </dropdown>
      </b-table-column>
      <b-table-column v-slot="props" :width="100">
        <button class="button is-primary" @click="updateGPSData(props.row)">
          Opdater
        </button>
      </b-table-column>
    </b-table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import APISTATE from "../../enums/APISTATE";
import YearMonthPanel from "@/components/report/YearMonthPanel.vue";
import EmployeesPanel from "@/components/report/EmployeesPanel.vue";
import SubmitPanel from "@/components/report/SubmitPanel.vue";
import Dropdown from "@/components/common/Dropdown.vue";
import moment from "moment";
import Vue from 'vue';
import TRIPUSE from "../../enums/TRIPUSE";

export default {
  name: "gps-data-view",
  components: { YearMonthPanel, EmployeesPanel, SubmitPanel, Dropdown },
  props: {
    employeeNumber: {
      type: Number,
      required: undefined,
    },
  },
  data: () => ({
    employeeId: undefined,
    tripUseOptions: [],
  }),
  async mounted() {
    const tripUse = TRIPUSE;
    Object.entries(tripUse).map(([key, val]) => {
      this.tripUseOptions.push({ display: key, value: val });
    });
    
    if(this.gpsDataFilterYear === undefined || this.gpsDataFilterMonth === undefined){
      this.initYearMonth();
    }
  },
  computed: {
    ...mapGetters("gpsDataStore", ["gpsDataApiState","gpsDataFilterYear", "gpsDataFilterMonth", "gpsDataList", "gpsDataFilterEmployeeNumber"]),
    ...mapGetters(["currentUser", "hasEditRights"]),
    ...mapGetters(["currentUser", "isAdmin"]),
    loading() {
      return this.gpsDataApiState !== APISTATE.LOADED;
    },
  },
  methods: {
    ...mapActions("gpsDataStore", ["getAllGPSData", "updateGPSData","setYear","setMonth", "setEmployeeNumber", "initYearMonth"]),
    getDateFromMonthYear(day, month, year) {
      let date = new Date();
      date.setMonth(month);
      date.setFullYear(year);
      date.setDate(day);
      return date;
    },
    getLatestDayOfMonth(month, year) {
      return new Date(year, month + 1, 0).getDate();
    },
    async performLookup() {
      const fromDate = this.getDateFromMonthYear(1, this.gpsDataFilterMonth, this.gpsDataFilterYear);
      const toDate = this.getDateFromMonthYear(
        this.getLatestDayOfMonth(this.gpsDataFilterMonth, this.gpsDataFilterYear),
        this.gpsDataFilterMonth,
        this.gpsDataFilterYear
      );

      const dto = {
        assistantNumber: this.gpsDataFilterEmployeeNumber,
        fromDate: fromDate,
        toDate: toDate,
      };
      await this.getAllGPSData(dto);
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD/MM-YYYY");
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.table td {
  text-align: left !important;
}
.table-dropdown {
  width: 10px;
}
</style>
